// libraries
import React from 'react'
import clsx from 'clsx'

// components
import RichText from '/react4xp/components/RichText'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface ColumnCardProps {
    backgroundColor: 'beige' | 'green'
    ctas?: {
        text?: string
        href: string
        external?: boolean
    }[]
    tagline?: string
    title?: string
    text?: string
}

export default function ColumnCard({
    backgroundColor,
    ctas,
    tagline,
    title,
    text
}: ColumnCardProps) {
    return (
        <div className={clsx(
            'column-card',
            backgroundColor === 'beige' && 'column-card--beige',
            backgroundColor === 'green' && 'column-card--green'
        )}>

            {isNonWhitespaceString(tagline) && (
                <p className='column-card__tagline text-md'>
                    {tagline}
                </p>
            )}

            {isNonWhitespaceString(title) && (
                <p className='column-card__title title-sm font-title'>
                    {title}
                </p>
            )}

            {isNonWhitespaceString(text) && (
                <div className='column-card__text'>
                    <RichText content={text} />
                </div>
            )}

            {ctas?.map(cta => isNonWhitespaceString(cta?.href) && (
                <a
                    href={cta?.href}
                    target={cta?.external ? '_blank' : undefined}
                    className='column-card__cta text-md'
                >
                    {cta?.text} 
                    <svg width='19' height='17' viewBox='0 0 19 17' xmlns='http://www.w3.org/2000/svg'><path d='M10.75 16.33L9.34 14.91L15.09 9.16H0V7.16H15.09L9.34 1.41L10.75 0L18.91 8.16L10.75 16.33Z'/></svg>
                </a>
            ))}

        </div>
    )
}

